// Path: /home/jason/src/AgileView/autovision-ui/src/components/views/InferenceRealTimeSubView.tsx

import React from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectSelectedModelId } from '../../../store/slices/modelSlice'
import { useGetModelQuery } from '../../../services/modelsApi'
import styled from 'styled-components'
import MapComponent from './MapComponent'

const ViewContainer = styled.div`
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #1a1a1a;
  overflow: hidden;
`

const InferenceMapSubView: React.FC = () => {
  const selectedModelId = useAppSelector(selectSelectedModelId)
  const { data: selectedModel } = useGetModelQuery(selectedModelId || '', {
    skip: !selectedModelId,
  })

  if (!selectedModel) {
    return <div>No model data available.</div>
  }

  return (
    <ViewContainer>
      <MapComponent />
    </ViewContainer>
  )
}

export default InferenceMapSubView
